<ng-container *ngIf="membershipConfig$ | async as membershipConfig">
    <span>
        <ng-container
            *ngIf="
                membership$ | async;
                else elseTemplate
            "
        >
            <span class="user-type">
                <serviceos-ng-system-icon
                    [icon]="membershipConfig?.settings.membership_icon"
                ></serviceos-ng-system-icon>
                {{ membershipConfig?.texts.user_member }}
            </span>
        </ng-container>
        <ng-template #elseTemplate>
            <div #content>
                <serviceos-ng-link routerLink="/membership-club" [font_weight]="'semi-bold'">{{
                    membershipConfig?.texts.user_not_member
                }}</serviceos-ng-link>
            </div>
        </ng-template>
    </span>
</ng-container>
